import serverCall from "../../serverCall";

const getAllUser = (payload) => {
  try {
    const response = serverCall.post(`/admin/getall-user`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

const getUserDetails = (userId) => {
  try {
    const response = serverCall.get(`/admin/user/${userId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const createChat = (body, options) => {
  try {
    const response = serverCall.post(`/ai-conversation/create`, body, {
      signal: options?.signal,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const updateUser = (userId, body) => {
  try {
    const response = serverCall.put(`/admin/user/update/${userId}`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteUser = (userId) => {
  try {
    const response = serverCall.delete(`/admin/user/delete/${userId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// const clearSession = () => {
//   try {
//     const response = serverCall.get(`/ai-conversation/inActiveSession`);
//     return response;
//   } catch (error) {
//     throw error;
//   }
// };

/* const updateAdminProfile = (body, userId) => {
  try {
    const response = serverCall.patch(`/admin/update-profile`, body);
    return response;
  } catch (error) {
    throw error;
  }
}; */

/* const adminFileUpload = (body) => {
  try {
    const response = serverCall.post(`/company/update-company`, body);
    return response;
  } catch (error) {
    throw error;
  }
}; */

/* const getCompany = () => {
  try {
    const response = serverCall.get(`/company/get-companies`);
    return response;
  } catch (error) {
    throw error;
  }
}; */

const ChatService = {
  getAllUser,
  getUserDetails,
  createChat,
  updateUser,
  deleteUser,
  // clearSession,
  //   updateAdminProfile,
  //   adminFileUpload,
  //   getCompany,
};

export default ChatService;
